import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinimize45"><Path fillRule="evenodd" clipRule="evenodd" d="M21.6644 3.74991L16.4144 8.99991H21.0002V10.9999H13.0002V2.99991H15.0002V7.58569L20.2502 2.33569L21.6644 3.74991ZM3.00015 12.9999H11.0002V20.9999H9.00015V16.4141L3.75015 21.6641L2.33594 20.2499L7.58594 14.9999H3.00015V12.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize45;
